import Icon from '@klv/atoms/icon';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/carousel-button.module.scss';

import type { ICarouselButton } from './types';

const CarouselButton = ({ className = '', colorVariant = 'light', direction = 'left', onClick, ...props }: ICarouselButton) => (
  <button
    className={generateClassName([
      styles.carouselButton,
      colorVariant === 'light' ? styles.light : styles.dark,
      className,
    ])}
    data-direction={direction}
    onClick={onClick}
    {...props}
  >
    <Icon fillColor="currentColor" iconName="ChevronDown" />
  </button>
);

export default CarouselButton;
